interface Prop {
    content: string;
    className?: string;
}

// It is important that the content parsed to this component is not dynamically created as it is used to render HTML content.
const HelpText = ({ content, className = 'help-message text xxs' }: Prop) => {
    return (
        <p
            className={className}
            // biome-ignore lint/security/noDangerouslySetInnerHtml: The content from the backend is static and completely under our control.
            dangerouslySetInnerHTML={{ __html: content }}
        />
    );
};

export default HelpText;
